import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Container, Heading, rem, SimpleGrid, Stack, Text } from '@bonusly/design-system';

export interface StatusPageProps {
	graphic: ReactNode;
	status?: number;
	heading: string;
	subheading: string;
	link?: ReactNode;
}

export const StatusPage = ({ graphic, heading, link, status, subheading }: StatusPageProps) => {
	const { t } = useTranslation('monarch');

	return (
		<Container as="main" maxW={rem(1032)} paddingInline={{ base: 0, xs: 4 }} px={8}>
			<SimpleGrid gap={[5, null, 45]} alignItems="center" columns={[1, null, 2]}>
				{graphic}

				<Stack gap={6} alignItems="start">
					<Stack gap={2} alignItems="start">
						{status && (
							<Box alignItems="center" backgroundColor="gray.100" borderRadius={rem(60)} color="gray.700" display="inline-flex" justifyContent="center">
								<Box as="span" display="inline-flex" fontSize="md" fontWeight="medium" px={4}>
									{t('status.error', { status })}
								</Box>
							</Box>
						)}
						<Heading size="xl" lineHeight={1.25}>
							{heading}
						</Heading>
						<Text fontWeight={400} lineHeight={14 / 9}>
							{subheading}
						</Text>
					</Stack>
					{link ? (
						link
					) : (
						<Button as="a" href="/">
							{t('status.go_home')}
						</Button>
					)}
				</Stack>
			</SimpleGrid>
		</Container>
	);
};
